import { BILLING_MONTHS, lastDayOfMonth } from '../billing-search';

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * A period as its dates. What a statement itself shows - its page, its file
 * (`_period_cell` in backend/src/apps/billing/services/statement_export.py),
 * the MTD preview and Mark paid - because it is read and reconciled by them
 * (Tim, 2026-10-30).
 */
export const formatPeriodDates = (
  start: string | null,
  end: string | null
): string => {
  // An empty document has no period to name.
  if (!start || !end) return start ?? end ?? '-';
  return `${start} - ${end}`;
};

/**
 * How the statements list names a period (feedback 2026-10-22): "September
 * 2026" for a whole calendar month, the dates for any other span - nothing
 * keeps a stored statement to one month. The list only: everywhere else a
 * statement shows its dates (`formatPeriodDates`).
 *
 * Reads the ISO strings by hand, never through `Date`: `new Date('2026-09-01')`
 * is UTC midnight, which west of UTC is still August.
 */
export const formatStatementPeriod = (
  start: string | null,
  end: string | null
): string => {
  const range = formatPeriodDates(start, end);
  const from = ISO_DATE.exec(start ?? '');
  const to = ISO_DATE.exec(end ?? '');
  if (!from || !to) return range;
  const [, year, month, day] = from;
  const name = BILLING_MONTHS[Number(month) - 1]?.label;
  if (!name) return range;
  const wholeMonth =
    day === '01' &&
    to[1] === year &&
    to[2] === month &&
    Number(to[3]) === lastDayOfMonth(Number(year), Number(month));
  return wholeMonth ? `${name} ${year}` : range;
};
